<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">SPD Entry Log</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard"> Dashboard </router-link> / <b>TBA</b> /
      <b>SPD Entry Log</b>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12">
        <!-- Pending SPD Log -->
        <div class="card text-left mb-4">
          <div class="card-body">
            <h4 class="card-title mb-3">Pending SPD Entry Log</h4>
            <div class="table-responsive">
              <table class="table table-striped table-bordered text-center">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Sys ID</th>
                    <th>I.C No</th>
                    <th>Certificate No</th>
                    <th>Vehicle No</th>
                    <th>Sum Insured</th>
                    <th>Amount Paid</th>
                    <th>NCD</th>
                    <th>Source</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Purchased At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(spd, index) in pending_spd_lists"
                    :key="spd.sys_id"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ spd.sys_id }}</td>
                    <td>{{ spd.ic_number }}</td>
                    <td>{{ spd.certificate_number }}</td>
                    <td>{{ spd.vehicle_number }}</td>
                    <td>{{ spd.sum_covered }}</td>
                    <td>{{ spd.amount_paid }}</td>
                    <td>{{ spd.ncd }}%</td>
                    <td>{{ spd.source }}</td>
                    <td>{{ spd.start_date }}</td>
                    <td>{{ spd.end_date }}</td>
                    <td>
                      {{ spd.purchased_at | moment("DD/MM/YYYY H:mm:ss") }}
                    </td>
                    <td>
                      <button
                        class="btn btn-primary btn-block"
                        @click="repush(spd)"
                      >
                        Re-push
                      </button>
                      <router-link
                        class="btn btn-primary btn-block"
                        :to="redirect(spd.sys_id, 1)"
                        >View Details</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="d-flex justify-content-between mt-2">
              <button
                class="btn btn-primary"
                :disabled="pendingPage <= 1"
                @click="changePendingPage(-1)"
              >
                Previous
              </button>
              <span>Page {{ pendingPage }} of {{ pendingTotalPages }}</span>
              <button
                class="btn btn-primary"
                :disabled="pendingPage >= pendingTotalPages"
                @click="changePendingPage(1)"
              >
                Next
              </button>
            </div>
          </div>
        </div>

        <!-- Failed SPD Log -->
        <div class="card text-left mb-4">
          <div class="card-body">
            <h4 class="card-title mb-3">Fail SPD Entry Log</h4>

            <!-- Filter Dates -->
            <div class="row mb-3">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="dto.start_date"
                />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="dto.end_date"
                />
              </div>
            </div>

            <div class="text-right mb-2">
              <button
                class="btn btn-rounded btn-primary mr-2"
                style="width: 150px"
                @click="filter"
              >
                Filter
              </button>
              <button
                class="btn btn-rounded btn-primary"
                style="width: 150px"
                @click="reset"
              >
                Reset
              </button>
            </div>

            <div class="d-flex justify-content-between mb-2 mt-4">
              <button class="btn btn-primary" @click="exportFailToExcel">
                Excel
              </button>

              <input
                type="text"
                class="form-control"
                placeholder="Search..."
                v-model="failSearch"
                style="width: 300px"
              />
            </div>

            <div class="table-responsive">
              <table class="table table-striped table-bordered text-center">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Sys ID</th>
                    <th>I.C No</th>
                    <th>Certificate No</th>
                    <th>Vehicle No</th>
                    <th>Sum Insured</th>
                    <th>Amount Paid</th>
                    <th>NCD</th>
                    <th>Source</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Purchased At</th>
                    <th>Error</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(spd, index) in filteredFailList"
                    :key="spd.sys_id"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ spd.sys_id }}</td>
                    <td>{{ spd.ic_number }}</td>
                    <td>{{ spd.certificate_number }}</td>
                    <td>{{ spd.vehicle_number }}</td>
                    <td>{{ spd.sum_covered }}</td>
                    <td>{{ spd.amount_paid }}</td>
                    <td>{{ spd.ncd }}</td>
                    <td>{{ spd.source }}</td>
                    <td>{{ spd.start_date }}</td>
                    <td>{{ spd.end_date }}</td>
                    <td>
                      {{ spd.purchased_at }}
                    </td>
                    <td>{{ spd.message }}</td>
                    <td>
                      <button
                        class="btn btn-primary btn-block"
                        @click="repush(spd)"
                      >
                        Re-push
                      </button>
                      <router-link
                        class="btn btn-primary btn-block"
                        :to="redirect(spd)"
                      >
                        View Details
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="d-flex justify-content-between mt-2">
              <button
                class="btn btn-primary"
                :disabled="dto.page_no <= 1"
                @click="prevPage()"
              >
                Previous
              </button>
              <span>Page {{ dto.page_no }} of {{ totalPages }}</span>
              <button
                class="btn btn-primary"
                :disabled="dto.page_no >= totalPages"
                @click="nextPage()"
              >
                Next
              </button>
            </div>
          </div>
        </div>

        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSpdFailedRecords,
  createSpdRecord,
} from "@/services/SpdRecordService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from "xlsx";

export default {
  name: "tba_speed_records",
  components: { Loading },
  data() {
    const today = new Date();
    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(today.getDate() - 14);

    return {
      pending_spd_lists: [],
      fail_spd_lists: [],
      dto: {
        start_date: null,
        end_date: null,
        page_no: 1,
      },
      isLoading: false,
      fullPage: true,
      totalPages: 1,
      pendingPage: 1,
      pendingTotalPages: 1,
      failSearch: "",
    };
  },

  computed: {
    filteredFailList() {
      if (!this.failSearch) return this.fail_spd_lists;

      const search = this.failSearch.toLowerCase();
      return this.fail_spd_lists.filter((spd) =>
        Object.values(spd).some(
          (val) => val && val.toString().toLowerCase().includes(search)
        )
      );
    },
  },

  methods: {
    async loadPending(page = 1) {
      this.isLoading = true;
      this.pendingPage = page;

      // Example API call: replace with your pending API if different
      const response = await getSpdFailedRecords({
        ...this.dto,
        page_no: page,
      });
      this.pending_spd_lists = response.data.data;
      this.pendingTotalPages = response.data.total_pages || 1;
      this.isLoading = false;
    },

    async loadSpdEntry(page = 1) {
      this.isLoading = true;
      this.dto.page_no = page;

      try {
        const response = await getSpdFailedRecords(this.dto);
        this.fail_spd_lists = response.data.data;
        this.totalPages = response.data.total_pages || 1;
        this.dto.page_no = response.data.current_page;
      } catch (error) {
        swal("Try Again", error.response.data.message, "error");
      }

      this.isLoading = false;
    },

    async nextPage() {
      await this.loadSpdEntry(this.dto.page_no + 1);
    },

    async prevPage() {
      await this.loadSpdEntry(this.dto.page_no - 1);
    },

    async changePendingPage(delta) {
      await this.loadPending(this.pendingPage + delta);
    },

    async filter() {
      await this.loadSpdEntry(1);
    },
    async reset() {
      this.dto.start_date = null;
      this.dto.end_date = null;
      this.dto.page_no = 1;
      await this.loadSpdEntry(1);
    },

    async repush(spd) {
      this.isLoading = true;
      try {
        const response = await createSpdRecord(spd);

        if (response.data.success) {
          swal("Successfully pushed to SPD", response.data.message, "success");
          await this.loadSpdEntry(this.dto.page_no);
        } else {
          swal("Try Again", response.data.message, "error");
          this.isLoading = false;
        }

        // await this.loadPending(this.pendingPage);
      } catch (error) {
        swal("Try Again", error.response.data.message, "error");
      }
      this.isLoading = false;
    },

    redirect(spd) {
      // return `/tba/spd_records/${id}/${type}`;

      return {
        name: "tba_speed_record", // route name
        params: { sysId: spd.sys_id, type: 2 }, // params
        query: { spdData: JSON.stringify(spd) }, // pass full object
      };
    },

    exportFailToExcel() {
      // Only export filtered rows (current page)
      const rows = this.filteredFailList.map((spd) => ({
        SysID: spd.sys_id,
        ICNo: spd.ic_number,
        CertificateNo: spd.certificate_number,
        VehicleNo: spd.vehicle_number,
        SumInsured: spd.sum_covered,
        AmountPaid: spd.amount_paid,
        NCD: spd.ncd,
        Source: spd.source,
        StartDate: spd.start_date,
        EndDate: spd.end_date,
        PurchasedAt: spd.purchased_at,
        Error: spd.message,
      }));

      // Use xlsx library
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Fail SPD Log");

      XLSX.writeFile(wb, `fail_spd_page_${this.dto.page_no}.xlsx`);
    },
  },

  async created() {
    // await this.loadPending(1);
    await this.loadSpdEntry(1);
  },
};
</script>

<style>
.spanDateTime {
  display: none;
}
</style>
